import mapboxgl from 'mapbox-gl'; // or "const mapboxgl = require('mapbox-gl');"
import 'mapbox-gl/dist/mapbox-gl.css';
import React from "react";
import { useAppState } from "../../../AppListenerProvider";
import './WorldWeb.css';
import WorldWebOriginal from "./WorldWebOriginal";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

interface ContainerProps {
    lat: number;
    long: number;
    zoom: number;
    geojson: any;
    onClick?: any;
    blurred: boolean;
    flyTo: boolean;
    flyToCoords?: number[];
    flyToZoom?: number;
    isNative?: boolean;
    isSubscribed?: boolean;
    onBoundsChange?: (bounds: {
        ne_lat: number;
        ne_long: number;
        sw_lat: number;
        sw_long: number;
    }) => void;
    onUserLocationUpdate?: (coords: {
        latitude: number;
        longitude: number;
    }) => void;
}

// Container for Native vs. Original Web Map (Right now default to Original)
const WorldWeb: React.FC<ContainerProps> = (props) => {
    const { isNative } = useAppState();

    // if (isNative) {
    //     return <WorldWebNative {...props} />;
    // } else {
    //     return <WorldWebOriginal {...props} />;
    // }

    return <WorldWebOriginal {...props} />;
};

export default WorldWeb;
